export const supportEmail = "mina@mana.bio";
export const companyAddress = "HaMelacha St, 2, Tel Aviv Israel";
export const websiteUrl = "https://mina.mana.bio";
export const reportFormUrl =
  "https://forms.monday.com/forms/2ba8ae379f570d0c891568987370344c";
